const activateTab = (block, nextButton) => {
	const buttons = Array.from(block.querySelectorAll("[data-cw-tab-trigger]"));
	const panels = Array.from(block.querySelectorAll("[data-cw-tab-panel]"));
	const nextPanel = block.querySelector(`#${nextButton.getAttribute("aria-controls")}`);

	if (!nextPanel) {
		return;
	}

	buttons.forEach((button) => {
		const isActive = button === nextButton;

		button.classList.toggle("is-active", isActive);
		button.setAttribute("aria-selected", isActive ? "true" : "false");
		button.setAttribute("tabindex", isActive ? "0" : "-1");
	});

	panels.forEach((panel) => {
		const isActive = panel === nextPanel;

		panel.classList.toggle("is-active", isActive);
		panel.hidden = !isActive;
	});
};

const focusTab = (buttons, currentIndex, direction) => {
	const nextIndex = (currentIndex + direction + buttons.length) % buttons.length;
	const nextButton = buttons[nextIndex];

	nextButton.focus();
	nextButton.click();
};

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll("[data-cw-tab]").forEach((block) => {
		const buttons = Array.from(block.querySelectorAll("[data-cw-tab-trigger]"));

		buttons.forEach((button, index) => {
			button.addEventListener("click", () => activateTab(block, button));

			button.addEventListener("keydown", (event) => {
				if (event.key === "ArrowRight" || event.key === "ArrowDown") {
					event.preventDefault();
					focusTab(buttons, index, 1);
				}

				if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
					event.preventDefault();
					focusTab(buttons, index, -1);
				}
			});
		});
	});
});
